module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noAvailableAgents":"All agents are offline","agentStates":"Agent States"},"es":{"noAvailableAgents":"Todos los agentes están desconectados","agentStates":"Estado de Agentes"}}')
  delete Component.options._Ctor
}
